import { Card } from "antd";
import { useDataStore } from "../../store";
import { useState } from "react";

export function UserInfo () {

    const userInfo = useDataStore(state => state.userInfo);
    //通过eye的icon控制是否显示完整信息
    const [showFullInfo, setShowFullInfo] = useState(false);


    //姓名、身份证号、支付宝号、微信号脱敏显示，通过一个eye的icon控制是否显示完整信息
    if( !userInfo ) {
        return null;
    }

    let name = userInfo.name ? (userInfo.name[0] + '*'.repeat(userInfo.name.length - 1)) : '';
    let idcard = userInfo.idcard ? (userInfo.idcard.slice(0, 3) + '***********' + userInfo.idcard.slice(-4)) : '';
    let wechatID = userInfo.wechatID ? (userInfo.wechatID.slice(0, 1) + '****' + userInfo.wechatID.slice(-1)) : '';
    let alipayID = userInfo.alipayID ? (userInfo.alipayID.slice(0, 1) + '****' + userInfo.alipayID.slice(-1)) : '';

    const toggleShowFullInfo = () => {
        setShowFullInfo(!showFullInfo);
    }

    if( showFullInfo ) {
        name = userInfo.name || '';
        idcard = userInfo.idcard || '';
        wechatID = userInfo.wechatID || '';
        alipayID = userInfo.alipayID || '';
    }   

    return (
        // 使用antd做为UI库, 使用card组件, 2个字段一行, 显示用户的基本信息
        <Card title="用户信息" extra={<a onClick={toggleShowFullInfo}>{showFullInfo ? '隐藏' : '显示'}完整信息</a>} style={{ width: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <div style={{ width: '50%', 'line-height': '32px' }}>
                    <p><strong>姓名: </strong>{name}</p>
                    <p><strong>身份证号: </strong>{idcard}</p>
                    <p><strong>年龄: </strong>{userInfo.age}</p>
                    <p><strong>性别: </strong>{userInfo.gender === 'M' ? '男' : '女'}</p>
                </div>
                <div style={{ width: '50%', 'line-height': '32px' }}>
                    <p><strong>地区: </strong>{userInfo.addr}</p>
                    {wechatID && <p><strong>微信号: </strong>{wechatID}</p>}
                    {alipayID && <p><strong>支付宝号: </strong>{alipayID}</p>}
                </div>
            </div>
        </Card>
    );
}